import { render, staticRenderFns } from "./s-tpl-list.vue?vue&type=template&id=471dc952&scoped=true"
import script from "./s-tpl-list.vue?vue&type=script&lang=js"
export * from "./s-tpl-list.vue?vue&type=script&lang=js"
import style0 from "./s-tpl-list.vue?vue&type=style&index=0&id=471dc952&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471dc952",
  null
  
)

export default component.exports